//https://qiita.com/yamanoku/items/027308e23cfc69845d7e
// import IntersectionObserver from 'intersection-observer-polyfill';
// let IntersectionObserver = require('intersection-observer-polyfill/dist/IntersectionObserver');

// readyのあとじゃないとDOMが初期化されてなくてうまく監視できないことある
ready(() => {
    let ie2 = document.querySelector('body.ie');

    if (ie2 === null || ie2.length === 0) {
        let option = {
            root: null,
            rootMargin: "0px",
            threshold: [0]
            //        threshold: [0, 0.25, 0.5, 0.75, 1]
        };

        let observer2 = new IntersectionObserver(entries => {

            for (const e of entries) {

                let isIntersectionObserved = hasClassInEventTarget(e,'intersection-observed');

                let changeClass = isIntersectionObserved
                    ? 'intersected'
                    : 'separated';

                /***************************
                 *
                 * intersected
                 *
                 ***************************/
                if (e.intersectionRect.top ||
                    e.intersectionRatio > 0 ||
                    (typeof e.isIntersecting !== 'undefined' && e.isIntersecting)
                ) {

                    if (isIntersectionObserved) {
                        addClassToEventTarget(e, changeClass);
                    } else {
                        removeClassToEventTarget(e, changeClass);
                    }
                    continue;
                }

                /***************************
                 *
                 * separated
                 *
                 ***************************/
                if (isIntersectionObserved) {
                    removeClassToEventTarget(e, changeClass);
                } else {
                    addClassToEventTarget(e, changeClass);
                }
            }
        }, option);

        let targets2 = [...document.querySelectorAll('.intersection-observed, .separation-observed')];

        targets2.forEach(obj => observer2.observe(obj));

    }
});

// 監視したい要素をobserveする。
// observer.observe(document.querySelectorAll('.lazy-loading'));
